/**
 * Slider Component
 *
 * @file slider.js
 */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const swiper = new Swiper('.main-slider', {
      loop: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 1500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  };

  const newsSlider = () => {
    const swiperNews = new Swiper('.news-promo-slider', {
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }

  const init = () => {
    fullSlider();
    newsSlider();
  };

  return {
    init,
  };
})();

export default slider;
